import { shallowEqual, useSelector } from 'react-redux';
import { get } from 'lodash';
import moment from 'moment';

import { getCurrentSendedLanding, getCurrentSendedTakeOff, getTOCPoint, getTODPoint } from '../../selectors/sended-data';
import { TIMEOUT_IF_NO_TOC_POINT } from '../constants';

export const checkAlertEnabled = ({ allowed }) => allowed;
export const checkTodPoint = () => {
    const { todPoint } = useSelector(getTODPoint, shallowEqual);

    return Boolean(todPoint && todPoint.ato);
};

export const checkTakeOff = () => {
    const { takeOffTime } = useSelector(getCurrentSendedTakeOff);

    return Boolean(takeOffTime);
};

export const checkLanding = () => {
    const { landingTime, stopEngineTime, endWorkTime } = useSelector(getCurrentSendedLanding);

    return Boolean(landingTime || stopEngineTime || endWorkTime);
};

export const checkTocPoint = () => {
    const { tocPoint } = useSelector(getTOCPoint, shallowEqual);
    const ato = get(tocPoint, 'ato', null);

    return Boolean(ato);
};

export const checkDurationOfFlight = () => {
    const { takeOffTime } = useSelector(getCurrentSendedTakeOff);

    return moment.utc(takeOffTime).diff(moment.utc(), 'milliseconds') <= TIMEOUT_IF_NO_TOC_POINT;
};
